//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: "",
// },

export const portraitURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=1yCkkAG3R2jkf7D0EB31EAODNCeOYkAYc",
      frame: "Ansh Verma",
      location: "Golden avenue, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1j2ZL9JfKfERbmV9g1RA7L752wRqSEEPQ",
      frame: "Ansh Verma",
      location: "Golden avenue, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Fm2Pv0XQU6GV0OX7qhorxtTbnRW4feL8",
      frame: "Ansh Verma",
      location: "Golden avenue, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Lt5A3fTTFgBYPesO1XzaDL7psWwo6ySk",
      frame: "Ansh Verma",
      location: "Golden avenue, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1yq4NEzdIlUCUEmfY5S_IUaKxPTYUW7CN",
      frame: "Ansh Verma",
      location: "Golden avenue, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1wQU6ZbBbUWcFZRBWETHecIVw9ZwC9L79",
      frame: "Ansh Verma",
      location: "Golden avenue, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1DwG_obIvSQpwIzRwj51n6bFEk4MzTaoD",
    frame: "Ansh Verma (backlit with speedlight)",
    location: "Golden avenue, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1iWEUahSmFMhg1cubG9kCjuO-5hYWVn4t",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1HFObYEBE0w4_x0_OZBsrrbZSuRYR1J_d",
    frame: "Prankur Verma",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1dUZ_kvHvpJmwueSFJx04aE_7y5W0ixPf",
      frame: "Prankur Verma",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ENq8DoEa4ROSDwN8bpRErz2NdCmqdjpf",
      frame: "Prankur Verma",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1kSVQhJZ98OdPBpl4rWnlOXjrlOqN-kWe",
    frame: "Rakesh Verma (My dad)",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1MOwH_rYlLNmClrxfxB5k-A4tGrmcbPUd",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1BTnspj6kyqnj8-k9nYT88WtbA8iwCN_1",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=18TBsgkQy24LpqS7PtNa5hi2AMRXIN3c7",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=12INBGlbLUm9nafHiKLnCCNEzDttTSAV0",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1lYe_kbFg5U9QRf80RpckG2teOrvbVLkM",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1wKPJn18enWecELkPDRhUw9O-iiAYhGRx",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=18RuevfJZIPB3aQRC0ir16YHFgosQscZI",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1nP7bUkDJnH_Q9_dCrrateOlX33mhEDpB",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1p6qXff9vBE_SclpMBSWBam5wOF4tSZVJ",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1vbJmdMVvQa7RVjAFyXMPX0Qvs9C1Ip0U",
      frame: "Ansh Verma",
      location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1jo7QlTjQMYKBlbsSWy0y62UlBeoF9PY5",
    frame: "Ansh Verma",
    location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1j8W9P59mbo4d2Zio6RDtgBskDDbgIfOp",
    frame: "Ansh Verma",
    location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-7QWZ8h0N27XIvnwoc0_seWrJA2WQ2YP",
    frame: "High key portrait of Ansh Verma clicked in window light",
    location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1_3ZnRwwFOuTV9qxPA67rPK2TjbuIATzO",
    frame: "Ansh Verma",
    location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1LFRrFUFjWSgY5g39V64wHnsn_GgTdduX",
    frame: "Ansh Verma",
    location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1bmWstahU-AvKr8X6QGHLqSG8prJaJByI",
    frame: "Ansh Verma",
    location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1_4DMuhU0ZGnjdb74p9zotwA14_gNLus1",
    frame: "Ansh Verma",
    location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img: "https://drive.google.com/uc?export=view&id=1RHgA_VRHwl_fFOmwGEyj-i1_byQQGIT2",
    frame: "Ansh Verma (newspaper was morphed)",
    location: "Sheel Kunj, Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-YadkpoFmICRa7v1alDFuGAJOPGIwn_i",
    frame: "Random person in street",
    location: "Alka chowk, Pune, Maharashtra, India",
  },

  {
    img:
      "https://drive.google.com/uc?export=view&id=1-XMspCA7Q5elQyNWVM04bjlMym_9mOVH",
    frame: "Random person in street",
    location: "Alka chowk, Pune, Maharashtra, India",
  },

  {
    img:
      "https://drive.google.com/uc?export=view&id=1-lgtAS5PMNUSYkyqGeI2vda4xycRw5w6",
    frame: "Chhavi Sarda",
    location: "Alibaug, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-pff5k1xOGPWDdH37a5_cja506qoLY6s",
    frame: "Aastha Sachdeva",
    location: "Alibaug, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=109gEpHEOxcaNKYfBrF_nP_uK2Nr-U6eL",
    frame: "Chhavi Sarda",
    location: "Alibaug, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-vis1dX5hVC8RgvV1tu8wGYMCIJ79afq",
    frame: "Chhavi Sarda",
    location: "Alibaug, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10DOT4e1LB9JeQ7ktnm7A8vn3gCQXC5nd",
    frame: "Sukriti Saxena",
    location: "Alibaug, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10EP5p6n8aOC_1xlykUIpbJmVGEx5uqnQ",
    frame: "Abhishek Chandna",
    location: "Alibaug, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10ETgYCoxdl6b8B5YTIrsOdlMvyC59B7w",
    frame: "Avinash Gupta",
    location: "Alibaug, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-htZnoxJv-IyDkx_u24FTKH0VnDZX5ol",
    frame: "Avinash Gupta",
    location: "Lavasa, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-JSI0TF7lqB9qXMOwkzO9IyLsCiNRwJP",
    frame: "Lucy",
    location: "Meerut, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-KXvb9lzDXxuvYh71b-TVHibvhuyMXJc",
    frame: "Kalemau",
    location: "Pixcy sea resort, Mumbai, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-XGuWRRO6PGYj6V-q8ljDIphkksTfNi7",
    frame: "Kalemau",
    location: "Pixcy sea resort, Mumbai, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10cEkqrprkZDF-3FkHE_RRbfN1a2UXKpZ",
    frame: "Kalemau",
    location: "Pixcy sea resort, Mumbai, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10c_spbePrNCSAW1W6D8qk5WaDvtyUp65",
    frame: "Kalemau",
    location: "Pixcy sea resort, Mumbai, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10K_cWRmmuZT69zy_kDuKiJnup_tiWQyV",
    frame: "Kartik Sharma, Abhishek  Chandna",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-g-_7YVzojaRXNiqMzIApSYH6QwRIv1h",
    frame: "Abbas Jamali",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-dxsWehF9ArbgGBtjk3Cf0d7YLeSGXQE",
    frame: "Abbas Jamali",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10lF5hVUU4dLAmhR1rS_1TtRHriBqR4l_",
    frame: "Abbas Jamali",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10gNgYsXCH2Fan_AMQbGv8J0ItHchWUnV",
    frame: "Abbas Jamali",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-_X6hfcsF-UjknHRTVT_TYDhtRzAGnQ5",
    frame: "Abbas Jamali, Abhishek Chandna",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12KdnIOmuYbadtWagiI2r2vgN5SJc5KU4",
    frame: "Abbas Jamali, Abhishek Chandna",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12M59WyeLPacb5Bapp1DI6CZEVqzNEjEh",
    frame: "Abbas Jamali, Abhishek Chandna",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12FZMMCeGoilJWaagbzaQYd0P4QGJYcwr",
    frame: "Abbas Jamali, Abhishek Chandna",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-gWlcBI_GVQGeEdnbgtu707AvMBaqCna",
    frame: "Khyati Gupta",
    location: "Infosys, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12_G5U29e-SrjFdqnhnme5ZrP4X0oXSpK",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1205LI4asY9yOgNo5t8sBrHDf7BlmRCq9",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11wViRLLsw8f-Vf1xLvPbF0Fv88zwYeEY",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10nwHHqkcYLjBofYrN8FAUmy17TUkkNvz",
    frame: "Khyati Gupta",
    location: "Infosys Ltd., Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11WMKpJEREXinoDB_k1eTjTNd3PzC-CLS",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10o8YucxsHwSuiuOF1Yp9XpogOxvZSDY-",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11T06CptFdtUZGaWxeSmT019yj1s5BQ-T",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11t15RggCVrZyEycstfd_61UwqeanfWG1",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=117oBOVDZVJ4tiGo8niqSuy7zTaO2NPiR",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11ETrXIF91grQUsPdoZm08xOhX4A0Excl",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10eBY_dkonlum9d4Uml8-E6JYO09D43XV",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11QYeiq9huJL3n3OZBPmoeHy9S-QGEk9k",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10t-oZ3OS36bwMCxStU397BStPIs3gYhm",
    frame: "Khyati Gupta",
    location: "TinselTown, Pune, Maharashtra India",
  },
  // {
  //   img:
  //     "https://drive.google.com/uc?export=view&id=10_NAx7B5AKw7ujH50KcH11YvIJopNMk8",
  //   frame: "Kushal Verma",
  //   location: "Meerut, UttarPradesh India",
  // },
  // {
  //   img:
  //     "https://drive.google.com/uc?export=view&id=122FT_OjCULkz85QgczGXjlLXbpEaErc8",
  //   frame: "Kushal Verma",
  //   location: "Meerut, UttarPradesh India",
  // },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-7banvXSmCbodNWQnLLIWY4ykPv1ThNU",
    frame: "Pranay Raghunathbatla",
    location: "Infosys Ltd., Mysore, Karnataka India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10Kz5hMEKKSB__bWQmSXgn3aAEDvDkjKi",
    frame: "Tanisha Mathur",
    location: "Infosys Ltd., Mysore, Karnataka India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10O9qWvN7MATBHxtcojAJJoFGdN2QiNai",
    frame: "Nipun Bhatnagar",
    location: "Infosys Ltd., Mysore, Karnataka India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10So7n2zIK6W9LkcA-X6JSZVafM-Nuoru",
    frame: "Mansha Manchanda",
    location: "Infosys Ltd., Pune, Maharashtra India",
  },
];
